import { render, staticRenderFns } from "./HonorService.vue?vue&type=template&id=19906770"
import script from "./HonorService.vue?vue&type=script&lang=js"
export * from "./HonorService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports